import styled from 'styled-components';
import { InputText } from 'ui/inputs/inputText/InputText';
import { Body2 } from 'ui/theme/typography/components';

export const ListWrapper = styled.div`
  border: ${(props) => props.theme.spacing.values.single} solid
    ${(props) => props.theme.colors.neutrals.grey15};
  border-radius: 6px;
  display: grid;
  grid-template-areas: 'header' 'body' 'footer';
  grid-template-rows: ${(props) =>
    `${props.theme.spacing.utils.pxToRem(72)} minmax(${props.theme.spacing.utils.pxToRem(
      40,
    )}, ${props.theme.spacing.utils.pxToRem(346)}) ${props.theme.spacing.utils.pxToRem(52)}`};
`;

export const Header = styled.div`
  border-bottom: ${(props) => props.theme.spacing.values.single} solid
    ${(props) => props.theme.colors.neutrals.grey15};
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas: 'search actions';
  grid-area: header;
  padding: ${(props) => props.theme.spacing.values.base};
`;
export const SearchInput = styled(InputText)`
  grid-area: search;
`;

export const Actions = styled.div`
  margin-left: ${(props) => props.theme.spacing.values.base};
  grid-area: actions;
`;
export const Body = styled.div`
  grid-area: body;
  overflow-y: auto;
`;

export const EmptyStateWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

export const Footer = styled.div`
  border-top: ${(props) => props.theme.spacing.values.single} solid
    ${(props) => props.theme.colors.neutrals.grey15};
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas: 'itemCount additionalText';
  grid-area: footer;
  padding: ${(props) => props.theme.spacing.values.base};
`;

export const FooterText = styled(Body2)`
  color: ${(props) => props.theme.colors.textColors.textSecondary};
  margin: 0;
`;

export const ItemCount = styled(FooterText)`
  grid-area: itemCount;
`;

export const AdditionalText = styled(FooterText)`
  grid-area: additionalText;
`;
